import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { SlidersHorizontal, Check, RotateCcw } from "lucide-react";

// Yoğun veri tabloları için kolon göster/gizle + satır yoğunluğu kontrolü.
// Kolon ve yoğunluk düğmeleri düz <button> olduğundan menü kapanmaz — çoklu seçim yapılabilir.
export function ColumnToggle({ cols, visible, onToggle, density, onDensity, onReset, testid = "table-tools" }) {
  const hiddenCount = cols.filter((c) => !visible[c.key]).length;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid={`${testid}-btn`} variant="outline" size="sm" className="h-9 gap-1.5 border-slate-300 text-slate-600 hover:bg-slate-50">
          <SlidersHorizontal className="h-4 w-4 text-brand-green" /> Tablo
          {hiddenCount > 0 && <span className="rounded-full bg-brand-green/10 px-1.5 text-[10px] font-bold text-brand-green">{hiddenCount}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Satır Yoğunluğu</DropdownMenuLabel>
        <div className="flex gap-1 px-2 pb-2">
          <button type="button" data-testid={`${testid}-density-comfortable`} onClick={() => onDensity("comfortable")}
            className={`flex-1 rounded-md border px-2 py-1.5 text-xs font-medium transition-colors ${density === "comfortable" ? "border-brand-green bg-brand-green/10 text-brand-green" : "border-slate-200 text-slate-500 hover:bg-slate-50"}`}>Rahat</button>
          <button type="button" data-testid={`${testid}-density-compact`} onClick={() => onDensity("compact")}
            className={`flex-1 rounded-md border px-2 py-1.5 text-xs font-medium transition-colors ${density === "compact" ? "border-brand-green bg-brand-green/10 text-brand-green" : "border-slate-200 text-slate-500 hover:bg-slate-50"}`}>Sık</button>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Kolonlar</DropdownMenuLabel>
        <div className="max-h-64 overflow-y-auto py-1">
          {cols.map((c) => (
            <button key={c.key} type="button" data-testid={`${testid}-col-${c.key}`} disabled={c.locked} onClick={() => onToggle(c.key)}
              className={`flex w-full items-center justify-between px-2 py-1.5 text-sm transition-colors ${c.locked ? "cursor-not-allowed text-slate-300" : "text-slate-700 hover:bg-slate-50"}`}>
              <span>{c.label}</span>
              <span className={`flex h-4 w-4 items-center justify-center rounded border ${visible[c.key] ? "border-brand-green bg-brand-green text-white" : "border-slate-300 bg-white"}`}>
                {visible[c.key] && <Check className="h-3 w-3" />}
              </span>
            </button>
          ))}
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid={`${testid}-reset`} onClick={onReset}><RotateCcw className="mr-2 h-3.5 w-3.5" /> Varsayılana dön</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ColumnToggle;
